import { render } from "./DeploymentManager.vue?vue&type=template&id=f96b6b74"
import script from "./DeploymentManager.vue?vue&type=script&lang=js"
export * from "./DeploymentManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__